import { Mutation } from 'graphql/generated/graphqlTypes';

export function mockedDeleteVisitorByIdData(deleteVisitorById: string | null): Pick<Mutation, 'deleteVisitorById'> {
  return {
    deleteVisitorById
  };
}

export const mockedDeleteVisitorByIdDataForMutation = mockedDeleteVisitorByIdData('mockedVisitorIdExternalUser1');
